import { render, staticRenderFns } from "./GetAQuote.vue?vue&type=template&id=1dd3f229&scoped=true"
import script from "./GetAQuote.vue?vue&type=script&lang=js"
export * from "./GetAQuote.vue?vue&type=script&lang=js"
import style0 from "./GetAQuote.vue?vue&type=style&index=0&id=1dd3f229&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd3f229",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VImg,VRow})
